import { InjectionToken } from '@angular/core';
export var DEFAULT_GRAPH_SETTINGS = new InjectionToken('DEFAULT_GRAPH_SETTINGS');
